import { ApiBaseFront } from "../../front/api-base-front";

type Params = {
  kijshopCd: string,
  favProductId: string,
};

export type PrintFavoriteProductData = {
  jsonList: {
    filename: string,
    body: string,
  }[],
};

export class ApiPrintFavoriteProductDataGet extends ApiBaseFront<{}> {
  constructor(param: Params) {
    const {
      kijshopCd,
      favProductId,
    } = param;

    super(
      'GET',
      `/api/v1/print/shop/${kijshopCd}/favProduct/${favProductId}`,
      'JSON',
      {},
    );
  }
}
